import { Toaster } from "sonner";

export default function ToasterProvider() {
    return (
        <Toaster
            position="top-center"
            richColors
            closeButton
            expand
            duration={4000}
            toastOptions={{
                classNames: {
                    toast:
                        "font-estedad text-xs shadow-xl border border-green-04/20 bg-white text-black relative flex items-center gap-3 pr-4 pl-10 !rounded-2xl",

                    content: "flex-1 text-right",

                    closeButton:
                        "!absolute !left-2 !right-auto !top-1/2 !-translate-y-1/2 !m-0 !p-1 rounded-md hover:bg-black/10",

                    title: "text-xs font-medium",
                    description: "text-xs opacity-80",

                    actionButton: "bg-green-04 text-white hover:bg-green-05",
                    cancelButton: "bg-gray-200 text-gray-700 hover:bg-gray-300",

                    success: "bg-green-03 text-green-06 border-green-04",
                    error: "bg-red-100 text-red-600 border-red-200",
                    warning: "bg-yellow-100 text-yellow-700 border-yellow-200",
                    info: "bg-blue-100 text-blue-700 border-blue-200",
                },
            }}
        />
    );
}
